// antd-mobile 2 and rmc-calendar still call ReactDOM.render and findDOMNode.
const { createRoot } = require('react-dom/client')
const ReactDOM = require('react-dom')

const internals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE
const roots = new WeakMap()

if (typeof ReactDOM.render !== 'function') {
  ReactDOM.render = function render(element, container) {
    let root = roots.get(container)
    if (!root) {
      root = createRoot(container)
      roots.set(container, root)
    }
    root.render(element)
    return {
      unmount() {
        root.unmount()
        roots.delete(container)
      }
    }
  }
}

if (typeof ReactDOM.unmountComponentAtNode !== 'function') {
  ReactDOM.unmountComponentAtNode = function unmountComponentAtNode(container) {
    const root = roots.get(container)
    if (!root) return false
    root.unmount()
    roots.delete(container)
    return true
  }
}

if (typeof ReactDOM.findDOMNode !== 'function') {
  ReactDOM.findDOMNode = function findDOMNode(componentOrElement) {
    if (componentOrElement == null) return null
    if (componentOrElement.nodeType === 1 || componentOrElement.nodeType === 3) {
      return componentOrElement
    }
    if (typeof internals.findDOMNode !== 'function') return null
    return internals.findDOMNode(componentOrElement)
  }
}
